import React, { useState } from 'react';
import logo from '../img/vana png.png';
import '../style/login.css';
import HomeIcon from '@mui/icons-material/Home';
import DOMPurify from 'dompurify'
import { Link, useNavigate,useLocation } from 'react-router-dom';
import Alert_Modals from '../components/Alert_Modals';
import api from '../api/api';
import SimpleBackdrop from '../components/SimpleBackdrop';
import { useDispatch } from 'react-redux';
import { setUser } from '../Store/userSlice';

function Loginpage() {
    const [formData,setData]=useState({
        email:"",
        password:"",
    });
    const dispatch=useDispatch();
    const navigate=useNavigate();
    const location=useLocation();
    const [loading,setLoading]=useState(false);
    const showModal=Alert_Modals();
    //function for striping all harmfullTags
    const sanitizeInput=(input)=>{
        return DOMPurify.sanitize(input);
    }
    
    //handel change in the input fileds
    const onHandelChange=(e)=>{

        setData((pre)=>(
            {
            ...pre,[e.target.name]:sanitizeInput(e.target.value)
            }
            ))
    }
    //handel form submit
    const handelSubmit=async(e)=>{
        e.preventDefault();
        setLoading(true);
        try {
            const response=await api.post('/auth/login',formData, {
                headers: { 'Content-Type': 'application/json' }
            });
          if(response.data.success){
            localStorage.setItem('Token',JSON.stringify(response.data.access_token));
            const res= await api.post(`/users/${response.data._id}`);
            if(res.data.success){
                showModal.showAlert("Login Successful","success","center").then(()=>{
                    localStorage.setItem('account',JSON.stringify(res.data.user));

                    dispatch(setUser(res.data.user));
                    const redirectPath = location.state?.from?.pathname || "/";
                    navigate(redirectPath);
    
                })
            }

            
          }
            
        } catch (error) {
            console.log(error);
            showModal.showAlert(error && error.response.data.errors[0].detail,'error','top-end').then(()=>{});
        }finally{
            setLoading(false);
        }
    }

    return (
        <div className='container  p-0 '>
            {loading && <SimpleBackdrop/>}
            <div className='row'>
                <div className='col-sm-12'>
                    <div className='d-flex justify-content-center'>
                        <img src={logo} loading='lazy' className='login-logo' alt='vana_logo' />
                    </div>
                    <div className='mt-5 col-sm-12 col-md-10 mb-3 rounded shadow  mx-auto '>
                        <div className='row shadow p-0 rounded  login-container '>
                            <div className='col-sm-12 col-md-6 order-2 order-md-1 py-5  px-3 bg-white  d-flex flex-column  align-items-center'>
                                <div className='d-flex w-100  justify-content-between px-3 align-items-center'>
                                    <div>
                                        <h3 className='fw-bold my-auto login-header-text'>Sign In</h3>
                                    </div>
                                    <div className='rounded-circle shadow p-2 login-homeicon-container'>
                                      <Link to="/" className='text-decoration-none'>  <HomeIcon className="login-homeicon" /></Link>
                                    </div>
                                </div>
                                <div className="w-100 mt-3  p-lg-4">
                                <form  onSubmit={handelSubmit} className=" mt-3">
                                        <div className= " form-floating mb-4 mt-3 ">
                                            <input type="email" value={formData.email} required  onChange={onHandelChange} className="form-control   login-inputs" id="email" placeholder="Enter email" name="email"/>
                                            <label for="email" className=" login-form-label text-start w-100">Email</label>
                                        </div>
                                        <div className=" form-floating mt-4 mb-3">
                                            <input type="password" value={formData.password} required onChange={onHandelChange} className="form-control login-inputs" id="pwd" placeholder="Enter password" name="password"/>
                                            <label for="pwd" className="login-form-label w-100 text-start">Password</label>
                                        </div>
                                        <div className="mb-3 mt-3 d-flex justify-content-between">
                                            <div className='form-check '>
                                            <label className="form-check-label text-start w-100">
                                            <input className="form-check-input"  type="checkbox" name="remember"/> Remember me
                                            </label>
                                            </div>
                                            <div>
                                            <span className='login-forgotpassword'>Forgotpassword</span>
                                            </div>
                                        </div>
                                        <div className='d-grid mt-4 '>
                                        <button type="submit" className=" p-2 btn btn-primary btn-block login-button">Sign In</button>

                                        </div>
                                        </form>
                                </div>
                                
                            </div>
                            <div className='col-sm-12 col-md-6 order-1 order-md-2 p-0  login-leftside  border-md-left'>
                                <div className="d-flex flex-column  justify-content-center h-100 my-2 p-4 my-auto">
                                <h6 className=' text display-4  fw-bold'> Welcome  Back to Vana</h6>
                                <h4 className='text  fw-bold'> Don't have an account ?</h4>
                                <Link to="/Signup" className='text-decoration-none py-3'><span className='btn login-signupButton'> Sign up</span></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Loginpage;
